module.exports = "<div class=\"loader\">\n  <div></div>\n  <div></div>\n</div>\n"